import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
type Role = "admin" | "employee";
export const PrivateRoute: React.FC<{children: ReactNode }> = ({

  children,
}) => {
  
  let { pathname } = useLocation();
  localStorage.setItem("pathName", pathname);
  const isLogged = localStorage.getItem("accessToken");
  const roleName: string | null = localStorage.getItem("roleName");
  const role:Role = roleName && (roleName === "admin" || roleName === "employee") ? roleName : "employee";;

  return !isLogged ? <Navigate to="/login" /> : <>{children}</>;
};
